import * as React from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';
import type {
  NWTEvent,
  PageViewTrackingEvent,
} from '@xing-com/crate-communication-tracking';

export type TrackNotificationsNWTProps =
  | NWTEvent
  | {
      event: string;
    };

type TrackNotificationsNWT = (props: TrackNotificationsNWTProps) => void;

type TrackNotifications = (
  props: PageViewTrackingEvent & {
    PropTrackAction?: string;
    PropActionOrigin?: string;
  }
) => void;

type UseNotificationsTracking = () => {
  trackNotificationsNWT: TrackNotificationsNWT;
  trackNotifications: TrackNotifications;
};

export const useNotificationsTracking: UseNotificationsTracking = () => {
  const { track } = useTracking();
  const trackNotificationsNWT: TrackNotificationsNWT = React.useCallback(
    (props) => {
      track({
        type: 'nwt',
        eventSchema: 'basic',
        sentBy: 'jobs',
        page: 'jobs/detail',
        application: 'wbm',
        ...props,
      });
    },
    [track]
  );

  const trackNotifications: TrackNotifications = React.useCallback(
    (props) => {
      track({
        type: 'pageview',
        channel: 'wbm/Notifications',
        ...props,
      });
    },
    [track]
  );

  return {
    trackNotifications,
    trackNotificationsNWT,
  };
};
